import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash'
import format from 'date-fns/format'
import addMonths from "date-fns/add_months";
import addDays from "date-fns/add_days";
import { getUserAll } from './core/cacheService';
export default {
    namespaced: true,
    state: {
        managerList: [],
        peopleList: [],
        memberKey: [],
        inforDailyData: [],
        inforWeeklyData: [],
        inforMonthlyData: [],
        p:'happily_2018',
        loadingDailyReportStatus: false,
        loadingWeeklyReportStatus: false,
        loadingMonthlyReportStatus: false,
        organization1level:{}
    },
    mutations: {
        setManagerList(state:any, result:any) {
            state.managerList = result
        },
        setPeopleList(state:any, result:any) {
            state.peopleList = result
        },
        setMemberKey(state:any, result:any) {
            state.memberKey = result
        },
        setInforDailyData(state:any, result:any) {
            state.inforDailyData = result
        },
        setInforWeeklyData(state:any, result:any) {
            state.inforWeeklyData = result
        },
        setInforMonthlyData(state:any, result:any) {
            state.inforMonthlyData = result
        },
        setloadingDailyReportStatus(state:any, result:any) {
            state.loadingDailyReportStatus = result
        },
        setloadingWeeklyReportStatus(state:any, result:any) {
            state.loadingWeeklyReportStatus = result
        },
        setloadingMonthlyReportStatus(state:any, result:any) {
            state.loadingMonthlyReportStatus = result
        },
        setOrganization1level(state:any, result:any) {
            state.organization1level = result
        },
    },
    actions: {
        async getPeopleOption({ commit, dispatch, rootState, state }: any, user: any) {
            let allUser:any
            const usersManager:Array<any> = [];
            if(Object.keys(state.memberKey).length == 0){
                allUser = await getUserAll(user.company)//rootState.main.allUser//(await firebase.database().ref('users').orderByChild("company").equalTo(user.company).once('value')).val()
                commit('setMemberKey', allUser);
            }
            if(rootState.newmember.results.length > 0){
                _.forEach(rootState.newmember.results, (value)=> {
                    const _item = value
                    _item.label = _item.firstname + " " + _item.lastname
                    _item.value = _item.email
                    if(rootState.authen.user.user_type == 'leadership'){
                        
                        if(state.organization1level[rootState.authen.user.team][value.team]){
                            usersManager.push(_item)
                        }

                    }else{
                        usersManager.push(_item)
                    }
                  
                });
                var _users = _.sortBy(usersManager, [function(o:any) { return o.label; }])
                commit('setPeopleList', _users)
            }else{
                _.forEach(state.memberKey, (value)=> {
                    const _item = value
                    _item.label = _item.firstname + " " + _item.lastname
                    _item.value = _item.email
                    if(rootState.authen.user.user_type == 'leadership'){
                        //console.log('state.organization1level',state.organization1level)
                        if(state.organization1level&&state.organization1level[rootState.authen.user.team][value.team]){
                            usersManager.push(_item)
                        }

                    }else{
                        usersManager.push(_item)
                    }
                    
                });
                var _users = _.sortBy(usersManager, [function(o:any) { return o.label; }])
                commit('setPeopleList', _users)
            }
        },
        async getManagerOption({ commit, dispatch, rootState, state }: any, user: any) {
            let allUser:any
            if(Object.keys(state.memberKey).length == 0){
                allUser = await getUserAll(user.company)//rootState.main.allUser//(await firebase.database().ref('users').orderByChild("company").equalTo(user.company).once('value')).val()
                commit('setMemberKey', allUser);
            }
            if(state.managerList.length == 0){
                const usersManager:Array<any> = [];
                const allBoss:Array<any> = [];
                for(const arrData in allUser){
                    const u = allUser[arrData]
                    if(u.boss){
                        let k_boss = allUser[arrData].boss.replace(/\./g, "||")
                        if(k_boss && allUser[k_boss] != undefined){
                            if(!allBoss[u.boss]){
                                allBoss[u.boss] = new Object()
                            }
                            allBoss[u.boss].label = allUser[k_boss].firstname + " " + allUser[k_boss].lastname
                            allBoss[u.boss].firstname = allUser[k_boss].firstname
                            allBoss[u.boss].lastname = allUser[k_boss].lastname
                            allBoss[u.boss].value = u.boss
                            allBoss[u.boss].team=allUser[k_boss].team
                        }
                    }
                }
                Object.entries(allBoss).forEach(([key, item]) =>{
                    if(rootState.authen.user.user_type == 'leadership'){
                        //console.log(' usersManager.push(item)',state.organization1level)
                        if(state.organization1level[rootState.authen.user.team][item.team]){
                            usersManager.push(item)
                        }

                    }else{
                        usersManager.push(item)
                    }
                    
                });
                
                var _users = _.sortBy(usersManager, [function(o:any) { return o.label; }])
                //console.log('_users',_users)


                commit('setManagerList', _users)
                // await firebase.database().ref().child('users').orderByChild('company').equalTo(`${user.company}`).once('value',async snapshot => {
                //     const usersManager:Array<any> = [];
                //     const allBoss:Array<any> = [];
                //     snapshot.forEach((arrData):any => {
                //         const u = arrData.val()
                //         if(u.boss){
                //             let k_boss = arrData.val().boss.replace(/\./g, "||")
                //             if(k_boss && allUser[k_boss] != undefined){
                //                 if(!allBoss[u.boss]){
                //                     allBoss[u.boss] = new Object()
                //                 }
                //                 allBoss[u.boss].label = allUser[k_boss].firstname + " " + allUser[k_boss].lastname
                //                 allBoss[u.boss].firstname = allUser[k_boss].firstname
                //                 allBoss[u.boss].lastname = allUser[k_boss].lastname
                //                 allBoss[u.boss].value = u.boss
                //             }
                //         }
                //     });
                //     Object.entries(allBoss).forEach(([key, item]) =>{
                //         usersManager.push(item)
                //     });
                //     var _users = _.sortBy(usersManager, [function(o:any) { return o.label; }])
                //     commit('setManagerList', _users)
                // }).catch(error => {
                //     console.log(error)
                // });
            }
        },
        getDataPreviewMonthly({ commit, dispatch, rootState, state }: any, form: any) {
            const inforData = {};
            let dataPreview:Array<any> = [];
            commit(`setloading${form.loading}ReportStatus`, true)
            commit(`setInfor${form.loading}Data`, {})
            firebase.firestore().collection('report_monthly').where("email", "==", form.user).where("monthyear", "==", form.date).get()
            .then(function (querySnapshot) {
                if(querySnapshot.empty){
                    inforData['deliveryStatus'] = ''
                    inforData['readStatus'] = ''
                    inforData['preview'] = ''
                    inforData['file'] = ''
                    inforData['file_name'] = ''
                    commit(`setInfor${form.loading}Data`, inforData)
                    commit(`setloading${form.loading}ReportStatus`, false)
                }else{
                    querySnapshot.forEach(function (doc) {
                        const _data = doc.data()
                        if(_data.link){
                            dataPreview.push(_data)
                        }
                    });
                    if(dataPreview.length > 0){
                        // let dateSend = format(addMonths(`${form.date}-01`, 1), 'YYYY-MM-DD')
                        // firebase.firestore().collection('sendemail').where("name", "==", `${form.type}_${form.user}`).where("date",">=",dateSend).orderBy("date","asc").limit(1).get()
                        // .then(function (querySnapshot) {
                        //     querySnapshot.forEach(function (doc) {
                        //         const _data = doc.data()
                        //         let path = _data.file;
                        //         const fstr = 'https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/';
                        //         const lstr = '?alt=media';
                        //         path = path.replace(/\//g, '%2F');
                        //         path = fstr + path + lstr;
                        //         inforData['file'] = path
                        //     });
                        //     dataPreview = _.orderBy(dataPreview,['createdate'], ['asc'])
                        //     let _data = dataPreview[dataPreview.length - 1]
                        //     const k_user = form.user.replace(/\./g, "||")
                        //     const fullname = (state.memberKey[k_user]) ? state.memberKey[k_user].firstname + " " + state.memberKey[k_user].lastname : ""
                        //     inforData['deliveryStatus'] = 'delivered' // Now Fix delivery Only
                        //     if(_data.trackOpen && _data.trackOpen == true && _data.readdate){
                        //         inforData['readStatus'] = 'Opened by ' + fullname + ' on ' + format(_data.readdate, 'MMMM D, YYYY [at] H:mm A')
                        //     }else{
                        //         inforData['readStatus'] = ''
                        //     }
                        //     inforData['preview'] = _data.link
                        //     let dateReport = form.date.replace(/-/g, "")
                        //     inforData['file_name'] = `${form.loading}Report_${(state.memberKey[k_user]) ? state.memberKey[k_user].firstname + (state.memberKey[k_user].lastname).charAt(0).toUpperCase() : ""}_${dateReport}`
                        //     commit(`setInfor${form.loading}Data`, inforData)
                        //     commit(`setloading${form.loading}ReportStatus`, false)
                        // });
                        inforData['file'] = ''
                        dataPreview = _.orderBy(dataPreview,['createdate'], ['asc'])
                        let _data = dataPreview[dataPreview.length - 1]
                        const k_user = form.user.replace(/\./g, "||")
                        const fullname = (state.memberKey[k_user]) ? state.memberKey[k_user].firstname + " " + state.memberKey[k_user].lastname : ""
                        inforData['deliveryStatus'] = 'delivered' // Now Fix delivery Only
                        if(_data.trackOpen && _data.trackOpen == true && _data.readdate){
                            inforData['readStatus'] = 'Opened by ' + fullname + ' on ' + format(_data.readdate, 'MMMM D, YYYY [at] H:mm A')
                        }else{
                            inforData['readStatus'] = ''
                        }
                        inforData['preview'] = _data.link
                        let dateReport = form.date.replace(/-/g, "")
                        inforData['file_name'] = `${form.loading}Report_${(state.memberKey[k_user]) ? state.memberKey[k_user].firstname + (state.memberKey[k_user].lastname).charAt(0).toUpperCase() : ""}_${dateReport}`
                        commit(`setInfor${form.loading}Data`, inforData)
                        commit(`setloading${form.loading}ReportStatus`, false)
                    }else{
                        inforData['deliveryStatus'] = ''
                        inforData['readStatus'] = ''
                        inforData['preview'] = ''
                        inforData['file'] = ''
                        inforData['file_name'] = ''
                        commit(`setInfor${form.loading}Data`, inforData)
                        commit(`setloading${form.loading}ReportStatus`, false)
                    }
                }
            });
        },
        getDataPreview({ commit, dispatch, rootState, state }: any, form: any) {
            const inforData = {};
            let dataPreview:Array<any> = [];
            commit(`setloading${form.loading}ReportStatus`, true)
            commit(`setInfor${form.loading}Data`, {})
            firebase.firestore().collection('sendemail').where("email", "==", form.user).where("date", "==", form.date).where("type", "==", form.type).get()
            .then(function (querySnapshot) {
                if(querySnapshot.empty){
                    inforData['deliveryStatus'] = ''
                    inforData['readStatus'] = ''
                    inforData['preview'] = ''
                    inforData['file'] = ''
                    inforData['file_name'] = ''
                    commit(`setInfor${form.loading}Data`, inforData)
                    commit(`setloading${form.loading}ReportStatus`, false)
                }else{
                    querySnapshot.forEach(function (doc) {
                        const _data = doc.data()
                        if(_data.file){
                            dataPreview.push(_data)
                        }
                        // else{
                        //     inforData['deliveryStatus'] = ''
                        //     inforData['readStatus'] = ''
                        //     inforData['preview'] = ''
                        //     commit(`setInfor${form.loading}Data`, inforData)
                        //     commit(`setloading${form.loading}ReportStatus`, false)
                        // }
                    });
                    if(dataPreview.length > 0){
                        dataPreview = _.orderBy(dataPreview,['createdate'], ['asc'])
                        let _data = dataPreview[dataPreview.length - 1]
                        const k_user = form.user.replace(/\./g, "||")
                        const fullname = (state.memberKey[k_user]) ? state.memberKey[k_user].firstname + " " + state.memberKey[k_user].lastname : ""
                        inforData['deliveryStatus'] = 'delivered' // Now Fix delivery Only
                        if(_data.trackOpen && _data.trackOpen == true && _data.readdate){
                            inforData['readStatus'] = 'Opened by ' + fullname + ' on ' + format(_data.readdate, 'MMMM D, YYYY [at] H:mm A')
                        }else{
                            inforData['readStatus'] = ''
                        }
                        inforData['preview'] = ''
                        firebase.storage().ref(`${_data.file}`).getDownloadURL().then(downloadURL => {
                            if(downloadURL !== undefined && downloadURL !== ''){
                                if(form.type === 'report_daily_boss'){
                                    fetch(downloadURL)
                                    .then( r => r.text() )
                                    .then((t) => {
                                        const regex = /style="font-size: 16px; font-style: italic;font-family: 'Lato', Arial, Helvetica, sans-serif;">(.|\n)*?<\/div>/g;
                                        const found = t.match(regex);
                                        for(const x in found){
                                            const sp = found[x].split(' - ');
                                            let text = '';
                                            for(let i = 0; i < sp.length; i++){
                                                if(i == (sp.length-1)){
                                                    text += '</p></div>';
                                                }else{
                                                    text += sp[i];
                                                }
                                                t = t.replace(found[x],text); 
                                            }
                                        }
                                        let found2;
                                        if(!found){
                                            const regex2 = /<div style="font-size:12px;line-height:14px;color:#FFF;font-family:\'Lato\', Tahoma, Verdana, Segoe, sans-serif;text-align:center;"><p style="margin: 0;font-size: 14px;line-height: 17px">(.|\n)*?<\/p><\/div>/g;
                                            found2 = t.match(regex2);
                                            for(const x in found2){
                                                const sp = found2[x].split(' - ');
                                                let text = '';
                                                for(let i = 0; i < sp.length; i++){
                                                    if(i == (sp.length-1)){
                                                        text += '</p></div>';
                                                    }else{
                                                        text += sp[i];
                                                    }
                                                }
                                                t = t.replace(found2[x],text); 
                                            }
                                            
                                        }
                                        if(!found && !found2){
                                            const regex2 = /<div class="text-response" style="margin: 24px 3.6rem 0; font-family: \'Lato\', Tahoma, sans-serif; color: #fff; font-size: 14px;">(.|\n)*?<\/div>/g;
                                            found2 = t.match(regex2);
                                            for(const x in found2){
                                                const sp = found2[x].split(' - ');
                                                let text = '';
                                                for(let i = 0; i < sp.length; i++){
                                                    if(i == (sp.length-1)){
                                                        text += '</div>';
                                                    }else{
                                                        text += sp[i];
                                                    }
                                                }
                                                t = t.replace(found2[x],text); 
                                            }
                                        }
                                        let beforeThisDay = form.date
                                        beforeThisDay = format(addDays(beforeThisDay,-1),"YYYY-MM-DD")
                                        let dateReport = format(beforeThisDay,"YYYYMMDD");
                                        inforData['preview'] = t
                                        inforData['file'] = downloadURL
                                        inforData['file_name'] = `${form.loading}Report_${(state.memberKey[k_user]) ? state.memberKey[k_user].firstname + (state.memberKey[k_user].lastname).charAt(0).toUpperCase() : ""}_${dateReport}`
                                        commit(`setInfor${form.loading}Data`, inforData)
                                        commit(`setloading${form.loading}ReportStatus`, false)
                                    })
                                }else{
                                    let beforeThisDay = form.date
                                    let dateReport = format(beforeThisDay,"YYYYMMDD");
                                    inforData['preview'] = downloadURL
                                    inforData['file'] = downloadURL
                                    inforData['file_name'] = `${form.loading}Report_${(state.memberKey[k_user]) ? state.memberKey[k_user].firstname + (state.memberKey[k_user].lastname).charAt(0).toUpperCase() : ""}_${dateReport}`
                                    commit(`setInfor${form.loading}Data`, inforData)
                                    commit(`setloading${form.loading}ReportStatus`, false)
                                }
                            }
                        }).catch(function (error) {

                        });
                    }else{
                        inforData['deliveryStatus'] = ''
                        inforData['readStatus'] = ''
                        inforData['preview'] = ''
                        inforData['file'] = ''
                        inforData['file_name'] = ''
                        commit(`setInfor${form.loading}Data`, inforData)
                        commit(`setloading${form.loading}ReportStatus`, false)
                    }
                }
            });
        },
        async getOrganization1level({ commit, dispatch, rootState, state }: any   ,user :  any) {
            const organization1level: { [key: string]: string } = {};
        await firebase.firestore().collection('organization1level').where("company", "==", rootState.authen.user.company).get()
            .then(function (querySnapshot) {
                querySnapshot.forEach(function (doc) {
                       if(doc.data().team_id){
                        organization1level[doc.data().team_id]=doc.data().parent
                       }
                        
                })
                //console.log('organization1level',organization1level)
                commit('setOrganization1level',organization1level)
           
             
            })
        }
    },
    getters: {
        managerList : (state:any) => {
            return state.managerList
        },
        peopleList : (state:any) => {
            return state.peopleList
        },
        inforDailyData : (state:any) => {
            return state.inforDailyData
        },
        inforWeeklyData : (state:any) => {
            return state.inforWeeklyData
        },
        inforMonthlyData : (state:any) => {
            return state.inforMonthlyData
        },
        loadingDailyReportStatus : (state:any) => {
            return state.loadingDailyReportStatus
        },
        loadingWeeklyReportStatus : (state:any) => {
            return state.loadingWeeklyReportStatus
        },
        loadingMonthlyReportStatus : (state:any) => {
            return state.loadingMonthlyReportStatus
        },
    }
}